var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/booking.ts
var booking_exports = {};
__export(booking_exports, {
  AmountSchema: () => AmountSchema,
  BookingConfirmationSchema: () => BookingConfirmationSchema,
  BookingOfferSchema: () => BookingOfferSchema,
  BookingStatusSchema: () => BookingStatusSchema,
  BulkRatePlanOfferRequestSchema: () => BulkRatePlanOfferRequestSchema,
  CancellationFeeSchema: () => CancellationFeeSchema,
  CityTaxSchema: () => CityTaxSchema,
  CorpCodeRatesSchema: () => CorpCodeRatesSchema,
  CreateBookingBookerSchema: () => CreateBookingBookerSchema,
  CreateBookingMetadataSchema: () => CreateBookingMetadataSchema,
  CreateBookingReservationSchema: () => CreateBookingReservationSchema,
  DatedOfferChargeSchema: () => DatedOfferChargeSchema,
  DetailedAmountSchema: () => DetailedAmountSchema,
  FeeSchema: () => FeeSchema,
  NoShowFeeSchema: () => NoShowFeeSchema,
  OfferChargeSchema: () => OfferChargeSchema,
  OfferPriceSummarySchema: () => OfferPriceSummarySchema,
  OfferRequestSchema: () => OfferRequestSchema,
  OfferResultSchema: () => OfferResultSchema,
  OfferSchema: () => OfferSchema,
  PaymentInstallmentSchema: () => PaymentInstallmentSchema,
  PromoCodeRatesSchema: () => PromoCodeRatesSchema,
  PropertySchema: () => PropertySchema,
  RatePlanOfferRequestSchema: () => RatePlanOfferRequestSchema,
  RatePlanSchema: () => RatePlanSchema,
  SearchDateRangeParamsSchema: () => SearchDateRangeParamsSchema,
  SearchDateRangeTypeSchema: () => SearchDateRangeTypeSchema,
  SearchSpecialRatesParamsSchema: () => SearchSpecialRatesParamsSchema,
  SearchUnitGroupTypeSchema: () => SearchUnitGroupTypeSchema,
  ServiceDateSchema: () => ServiceDateSchema,
  ServiceDetailSchema: () => ServiceDetailSchema,
  ServiceOfferRequestSchema: () => ServiceOfferRequestSchema,
  ServiceOfferResultsSchema: () => ServiceOfferResultsSchema,
  ServiceOfferSchema: () => ServiceOfferSchema,
  ServiceSchema: () => ServiceSchema,
  ShoppingCartItemSchema: () => ShoppingCartItemSchema,
  ShoppingCartPriceSummarySchema: () => ShoppingCartPriceSummarySchema,
  SpecialRatePlansSchema: () => SpecialRatePlansSchema,
  TaxDetailSchema: () => TaxDetailSchema,
  TimeSliceSchema: () => TimeSliceSchema,
  UnitGroupOfferResultSchema: () => UnitGroupOfferResultSchema,
  UnitGroupOfferSchema: () => UnitGroupOfferSchema,
  UnitGroupSchema: () => UnitGroupSchema
});
import { z } from "zod";
var AmountSchema = z.object({
  amount: z.number(),
  currency: z.string()
});
var DetailedAmountSchema = z.object({
  grossAmount: z.number(),
  netAmount: z.number(),
  vatType: z.string(),
  vatPercent: z.number(),
  currency: z.string()
});
var SearchDateRangeTypeSchema = z.enum(["Specific", "Flexible"]);
var SearchDateRangeParamsSchema = z.object({
  type: SearchDateRangeTypeSchema,
  start: z.string().date().optional(),
  end: z.string().date().optional(),
  nights: z.number().optional()
});
var SearchUnitGroupTypeSchema = z.enum([
  "BedRoom",
  "MeetingRoom",
  "EventSpace",
  "ParkingLot",
  "Other"
]);
var SearchSpecialRatesParamsSchema = z.object({
  promoCode: z.string().optional(),
  corporateCode: z.string().optional(),
  hasAAA: z.boolean().optional(),
  hasAARP: z.boolean().optional(),
  hasGov: z.boolean().optional(),
  hasMilitary: z.boolean().optional()
});
var PropertySchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string()
});
var UnitGroupSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string(),
  maxPersons: z.number(),
  type: z.string()
});
var ServiceDetailSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string(),
  pricingUnit: z.string(),
  defaultGrossPrice: AmountSchema
});
var ServiceDateSchema = z.object({
  serviceDate: z.string(),
  amount: DetailedAmountSchema,
  isDefaultDate: z.boolean(),
  isMandatory: z.boolean(),
  availableCount: z.number().optional()
});
var ServiceSchema = z.object({
  service: ServiceDetailSchema,
  count: z.number(),
  availableCount: z.number().optional(),
  totalAmount: DetailedAmountSchema,
  prePaymentAmount: AmountSchema,
  dates: z.array(ServiceDateSchema).optional()
});
var FeeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  totalAmount: DetailedAmountSchema
});
var TaxDetailSchema = z.object({
  vatType: z.string(),
  vatPercent: z.number(),
  net: AmountSchema,
  tax: AmountSchema
});
var CityTaxSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  totalGrossAmount: AmountSchema,
  dates: z.array(
    z.object({
      serviceDate: z.string(),
      amount: DetailedAmountSchema
    })
  )
});
var RatePlanSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string(),
  isSubjectToCityTax: z.boolean()
});
var TimeSliceSchema = z.object({
  from: z.string(),
  to: z.string(),
  availableUnits: z.number(),
  baseAmount: DetailedAmountSchema,
  totalGrossAmount: AmountSchema,
  includedServices: z.array(
    z.object({
      service: ServiceDetailSchema.omit({
        pricingUnit: true,
        defaultGrossPrice: true
      }),
      serviceDate: z.string(),
      count: z.number(),
      amount: DetailedAmountSchema,
      pricingMode: z.string()
    })
  ).optional()
});
var CancellationFeeSchema = z.object({
  code: z.string(),
  name: z.string(),
  description: z.string(),
  dueDateTime: z.string(),
  fee: AmountSchema
});
var NoShowFeeSchema = z.object({
  code: z.string(),
  name: z.string(),
  description: z.string(),
  fee: AmountSchema
});
var OfferChargeSchema = z.object({
  name: z.string(),
  amount: z.number()
});
var DatedOfferChargeSchema = OfferChargeSchema.extend({
  date: z.string()
});
var PaymentInstallmentSchema = z.object({
  type: z.enum([
    "TransientPrepayment",
    "TransientPayAtStay",
    "MonthlyPrepayment",
    "MonthlyInstallment"
  ]),
  amount: z.number(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  dueDate: z.string().optional(),
  nights: z.number().optional()
});
var OfferPriceSummarySchema = z.object({
  itemizedRoomCharges: z.array(OfferChargeSchema),
  itemizedIncludedServices: z.array(OfferChargeSchema),
  itemizedAdditionalServices: z.array(OfferChargeSchema),
  itemizedTaxesAndFees: z.array(OfferChargeSchema),
  totalRoomCharges: z.number(),
  totalIncludedServices: z.number(),
  totalAdditionalServices: z.number(),
  totalTaxesAndFees: z.number(),
  totalPrepayment: z.number(),
  total: z.number(),
  installments: z.array(PaymentInstallmentSchema).optional()
});
var OfferSchema = z.object({
  arrival: z.string(),
  departure: z.string(),
  unitGroup: UnitGroupSchema,
  minGuaranteeType: z.string(),
  availableUnits: z.number(),
  ratePlan: RatePlanSchema,
  totalGrossAmount: AmountSchema,
  cancellationFee: CancellationFeeSchema,
  noShowFee: NoShowFeeSchema,
  timeSlices: z.array(TimeSliceSchema),
  services: z.array(ServiceSchema),
  fees: z.array(FeeSchema).optional(),
  taxDetails: z.array(TaxDetailSchema).optional(),
  isCorporate: z.boolean(),
  prePaymentAmount: AmountSchema,
  cityTaxes: z.array(CityTaxSchema).optional(),
  validationMessages: z.array(
    z.object({
      code: z.string(),
      message: z.string()
    })
  ).optional()
});
var BookingOfferSchema = OfferSchema.extend({
  pricingSummary: OfferPriceSummarySchema,
  promoCode: z.string().optional(),
  corporateCode: z.string().optional(),
  isMemberRate: z.boolean().optional()
});
var OfferResultSchema = z.object({
  property: PropertySchema,
  offers: z.array(OfferSchema)
});
var OfferRequestSchema = z.object({
  propertyId: z.string(),
  dateRange: SearchDateRangeParamsSchema,
  guests: z.number(),
  specialRates: SearchSpecialRatesParamsSchema.optional(),
  unitGroupTypes: z.array(SearchUnitGroupTypeSchema).optional()
});
var RatePlanOfferRequestSchema = z.object({
  ratePlanId: z.string(),
  arrival: z.string().date(),
  departure: z.string().date(),
  guests: z.number()
});
var ServiceOfferRequestSchema = z.object({
  ratePlanId: z.string(),
  dateRange: SearchDateRangeParamsSchema,
  guests: z.number()
});
var CreateBookingBookerSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string(),
  email: z.string()
});
var CreateBookingReservationSchema = z.object({
  arrival: z.string(),
  departure: z.string(),
  adults: z.number(),
  childrenAges: z.array(z.number()),
  guestComment: z.string().optional(),
  comment: z.string().optional(),
  channelCode: z.literal("Ibe"),
  promoCode: z.union([z.string(), z.null()]).optional(),
  corporateCode: z.union([z.string(), z.null()]).optional(),
  primaryGuest: CreateBookingBookerSchema,
  guaranteeType: z.string(),
  timeSlices: z.array(
    z.object({
      ratePlanId: z.string(),
      totalAmount: z.object({
        amount: z.number(),
        currency: z.string()
      }).optional()
    })
  ),
  services: z.array(z.object({ serviceId: z.string() })),
  prePaymentAmount: z.object({ amount: z.number(), currency: z.string() }),
  totalAmount: z.object({ amount: z.number(), currency: z.string() })
});
var CreateBookingMetadataSchema = z.object({
  type: z.literal("CreateIbeBooking"),
  ibeSessionId: z.string().optional(),
  reservations: z.array(CreateBookingReservationSchema),
  booker: CreateBookingBookerSchema,
  totalPrepayment: z.object({
    amount: z.number(),
    currency: z.string()
  }),
  total: z.object({
    currency: z.string(),
    amount: z.number()
  })
});
var SpecialRatePlansSchema = z.object({
  name: z.string(),
  code: z.string(),
  ratePlanIds: z.array(z.string()),
  isCorp: z.boolean().optional(),
  isCorpAR: z.boolean().optional()
});
var BulkRatePlanOfferRequestSchema = z.object({
  requests: z.array(RatePlanOfferRequestSchema),
  lastUpdated: z.string()
});
var ServiceOfferSchema = z.object({
  service: ServiceDetailSchema,
  count: z.number(),
  totalAmount: DetailedAmountSchema,
  prePaymentAmount: AmountSchema,
  fees: z.array(FeeSchema),
  dates: z.array(
    z.object({
      serviceDate: z.string(),
      amount: DetailedAmountSchema,
      isDefaultDate: z.boolean(),
      isMandatory: z.boolean()
    })
  )
});
var ServiceOfferResultsSchema = z.object({
  services: z.array(ServiceOfferSchema)
});
var PromoCodeRatesSchema = z.object({
  count: z.number(),
  promoCodes: z.array(
    z.object({
      code: z.string(),
      relatedRateplanIds: z.array(z.string())
    })
  )
});
var CorpCodeRatesSchema = z.object({
  companies: z.array(
    z.object({
      code: z.string(),
      canCheckOutOnAr: z.boolean(),
      ratePlans: z.array(
        z.object({
          id: z.string(),
          code: z.string(),
          corporateCode: z.string(),
          name: z.string()
        })
      )
    })
  ),
  count: z.number()
});
var ShoppingCartItemSchema = z.object({
  id: z.string(),
  propertyId: z.string(),
  offer: OfferSchema,
  additionalServices: z.array(ServiceOfferSchema),
  guests: z.number()
});
var ShoppingCartPriceSummarySchema = z.object({
  totalRoomCharges: z.number(),
  totalIncludedServices: z.number(),
  totalAdditionalServices: z.number(),
  totalTaxesAndFees: z.number(),
  totalPrepayment: z.number(),
  balance: z.number(),
  total: z.number()
});
var UnitGroupOfferSchema = z.object({
  propertyId: z.string(),
  unitGroup: UnitGroupSchema,
  availableUnits: z.number(),
  nights: z.number(),
  offers: z.array(BookingOfferSchema)
});
var UnitGroupOfferResultSchema = z.object({
  propertyId: z.string(),
  unitGroupOffers: z.array(UnitGroupOfferSchema)
});
var BookingStatusSchema = z.enum([
  "Inactive",
  "Processing",
  "Success",
  "Failure"
]);
var BookingConfirmationSchema = z.object({
  bookingId: z.string().nullable().optional(),
  bookingStatus: BookingStatusSchema
});
export {
  booking_exports as booking
};
//# sourceMappingURL=index.mjs.map